var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("NOSComponent", {
        ref: "NOS_COMPONENT",
        attrs: { component: this.NOS_INSTANCE.components }
      }),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("contents-header", {
            attrs: {
              "bg-type": true,
              "no-radius": true,
              title: "MOTP-01-04-01-01",
              description: "MOTP-01-04-01-02"
            }
          }),
          _c("article", { staticClass: "contents" }, [
            _c("div", [
              _c("form", { staticClass: "form" }, [
                _c(
                  "div",
                  { staticClass: "form-text-field" },
                  [
                    _c("acno-select-box", {
                      attrs: {
                        "in-acn-knd": "1",
                        "in-acn-dtl-knd": "2",
                        label: _vm.$t("MOTP-01-04-01-03"),
                        value: _vm.getRBF0404B40.acnoSelect.acno,
                        detailValue: _vm.getRBF0404B40.acnoSelect.acnoDetail
                      },
                      on: {
                        "update:value": function($event) {
                          return _vm.$set(
                            _vm.getRBF0404B40.acnoSelect,
                            "acno",
                            $event
                          )
                        },
                        "update:detailValue": function($event) {
                          return _vm.$set(
                            _vm.getRBF0404B40.acnoSelect,
                            "acnoDetail",
                            $event
                          )
                        },
                        "update:detail-value": function($event) {
                          return _vm.$set(
                            _vm.getRBF0404B40.acnoSelect,
                            "acnoDetail",
                            $event
                          )
                        },
                        change: _vm.acnoChange
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "form-text-field" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "name" } },
                    [_vm._v(" " + _vm._s(_vm.$t("MOTP-01-04-01-04")) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "input-text-field",
                      on: {
                        click: function($event) {
                          _vm.type2 = true
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "item-desc" },
                        [
                          _c("acno-password", {
                            ref: "brncoEcrypPwd",
                            attrs: {
                              id: "brncoEcrypPwd",
                              NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "notice notice-box--type" }, [
              _c("div", { staticClass: "notice-tit" }, [
                _c("p", { staticClass: "bullet" }, [
                  _vm._v(_vm._s(/*유의사항*/ _vm.$t("MOTP-01-04-01-05")))
                ])
              ]),
              _c("div", { staticClass: "notice-cont" }, [
                _c("p", [
                  _vm._v(" " + _vm._s(_vm.$t("MOTP-01-04-01-06")) + " ")
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "btn-area--full fixed" }, [
        _c(
          "button",
          {
            class:
              "btn md " +
              (_vm.getRBF0404B40.acnoSelect.acno !== "" &&
              _vm.getRBF0404B40.acnoSelect.acnoDetail.acnKnd !== "" &&
              this.NOS_INSTANCE.toJSON().brncoEcrypPwd !== "" &&
              this.NOS_INSTANCE.toJSON().brncoEcrypPwd.length === 4
                ? "normal"
                : "disabled"),
            on: { click: _vm.FN001 }
          },
          [_vm._v(_vm._s(/*인증하기*/ _vm.$t("MOTP-01-04-01-07")))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }